export default __webpack_public_path__ + "static/media/promotions.2dfaa0bf.png";